import React from 'react';

function Mute() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M18 12c0-2.36-1.36-4.387-3.333-5.373v2.946l3.266 3.267c.04-.267.067-.547.067-.84zm3.333 0c0 1.253-.266 2.427-.72 3.52l2.014 2.013C23.507 15.88 24 14 24 12 24 6.293 20.013 1.52 14.667.307v2.746C18.52 4.2 21.333 7.773 21.333 12zM1.693 0L0 1.693 6.307 8H0v8h5.333L12 22.667v-8.974l5.667 5.667c-.894.693-1.894 1.24-3 1.573v2.747c1.84-.413 3.506-1.267 4.92-2.413L22.307 24 24 22.307l-12-12L1.693 0zM12 1.333L9.213 4.12 12 6.907V1.333z" />
    </svg>
  );
  /* eslint-enable */
}

export default Mute;



// WEBPACK FOOTER //
// ./src/common/icons/Mute.js